<template>
  <aha-modal
    @hide="hide()"
    title="Unpublish this template?"
  >
    Your template <strong>{{ presentation.name && presentation.name }}</strong>
    will be unpublished and removed from the Template Library.
    <template #action>
      <aha-button
        variant="danger"
        @click="handleUnpublish"
        has-margin-right
        :submitting="isPublishing"
      >
        Unpublish
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
import utils from '@/util'

export default {
  components: {
  },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    unpublish: {
      type: Function,
      default: () => {},
    },
    isPublishing: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async handleUnpublish() {
      try {
        await this.unpublish()
        this.$emit('hide')
      } catch (e) {
        // do nothing
      }
    },
    hide() {
      let category = ''
      switch (this.$route.name) {
        case 'Presentations':
          category = 'Presentation List > Kebab menu > Share Dialog'
          break
        case 'PresentationDetail':
          category = 'Presentation Editor > Share menu'
          break
        default:
          break
      }
      utils.gaTrackEvent(category, 'Cancel Unpublish', '', this.presentation.id)
      this.$emit('hide')
    },
  },
}
</script>
